// extracted by mini-css-extract-plugin
export default {"Container":"style_Container__JBASx","Photo":"style_Photo__I7wZh","Title":"style_Title__ICl4c"};